import infiltracaoImage from "../assets/Infiltracao.jpg";
import umidadeImage from "../assets/umidade-no-rodape.jpg";
import lajesImage from "../assets/telha-vazando.jpg";
import reservatorioImage from "../assets/vazamento-concreto.png";
import corrosaoImage from "../assets/Corrosao.jpg";
import calorImage from "../assets/reducao calor.jpeg";
import vedacaoImage from "../assets/Vedacao-Telhas.png";
import selamentoImage from "../assets/selamento de juntas.jpg";
import colagemImage from "../assets/colagem-rufo.png";
import colagemEstruturalImage from "../assets/colagem-concreto.jpg";
import reforcoImage from "../assets/recuperacao-concreto.jpg";

interface Solucoes {
    name: string,
    image?: any,
    altImage: string
}

export const Solucoes: Solucoes[] = [
    {
        name: 'INFILTRAÇÕES EM PAREDES E MUROS EXTERNOS',
        image: infiltracaoImage,
        altImage: 'INFILTRAÇÕES'
    },
    {
        name: 'TRATAMENTO CONTRA UMIDADE DE PÉ DE PAREDE OU MOFO DE RODAPÉ',
        image: umidadeImage,
        altImage: 'Umidade'
    },
    {
        name: 'TRATAMENTO CONTRA LAJES EXPOSTAS, TELHAS E  CALHAS VAZANDO',
        image: lajesImage,
        altImage: 'Lajes'
    },
    {
        name: 'RESERVATÓRIOS DE CONCRETO VAZANDO',
        image: reservatorioImage,
        altImage: 'RESERVATÓRIOS'
    },
    {
        name: 'LAJES DE COBERTURA, PLAYGROUDS, GARAGENS COM CORROSÃO E INFILTRAÇÕES',
        image: corrosaoImage,
        altImage: 'CORROSÃO'
    },
    {
        name: 'REDUÇÃO DO CALOR E IMPERMEABILIZAÇÃO DE DE TELHAS METÁLICAS E FIBRO CIMENTOS ',
        image: calorImage,
        altImage: 'CALOR'
    },
    {
        name: 'VEDAÇÃO EM TELHAS, RUFOS, CALHAS',
        image: vedacaoImage,
        altImage: 'VEDAÇÃO'
    },
    {
        name: 'SELAMENTO DE JUNTAS DE PISOS E FACHADAS,',
        image: selamentoImage,
        altImage: 'SELAMENTO'
    },
    {
        name: 'COLAGEM FLEXÍVEL DE RUFOS, CALHAS, ESPELHOS, CUBAS, PIAS, VASOS SANITÁRIOS',
        image: colagemImage,
        altImage: 'COLAGEM'
    },
    {
        name: 'COLAGENS ESTRUTURAIS DE CONCRETO COM CONCRETO, FERRO E FIXADORES EM CONCRETO',
        image: colagemEstruturalImage,
        altImage: 'COLAGENS'
    },
    {
        name: 'REFORÇO E RECUPERAÇÃO ESTRUTURAL EM CONCRETO DE PISOS, PILARES, VIGAS E LAGES',
        image: reforcoImage,
        altImage: 'REFORÇO'
    }
];

